<template>
  <section>
    <div v-if="loading">
      <!-- Edit -->
      <email-edit-modal
        v-if="boxedit"
        :nums="nums"
        :users="users"
        :states="states"
        :usersession="usersession"
        :email_current="email_current"
        :email_id="email_current || route.query.email"
        @emailEdited="emailEdited()"
        @closeEditEmail="closeEditEmail()"
      />
      <!-- END: Edit -->

      <!-- Filter -->
      <div v-if="this.$route.path !== '/admin/pendings-emails'">
        <div
          class="intro-y flex flex-col-reverse mt-3 sm:flex-row items-center"
        >
          <h2 class="intro-y text-lg font-medium mr-auto mt-8">
            Cortes <app-title-custom /> ({{ filteredEmails.length }})
          </h2>
        </div>
        <div
          class="intro-y flex flex-col-reverse mt-2 sm:flex-row items-center"
        >
          <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0">
            <app-icon
              name="search"
              classname="w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700"
            />
            <input
              type="text"
              class="input w-full sm:w-64 box px-10 text-gray-700"
              placeholder="Buscar por nombre"
              v-model="filter.name"
            />
            <div
              class="inbox-filter dropdown hidden md:block md:absolute inset-y-0 mr-3 right-0 flex items-center"
            >
              <app-icon
                name="chevron-down"
                classname="dropdown-toggle w-4 h-4 mt-3 cursor-pointer text-gray-700"
              />
              <div
                class="inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20"
              >
                <div class="dropdown-box__content box p-5">
                  <div class="grid grid-cols-12 gap-4 row-gap-3">
                    <div class="col-span-6">
                      <div class="text-xs">Estado</div>
                      <select
                        class="input w-full border mt-2 flex-13"
                        v-model="filter.state"
                        required
                      >
                        <option :value="null">Seleccione una opción</option>
                        <option
                          v-for="state in states"
                          :value="state.id"
                          v-if="state.id != 7"
                        >
                          {{ state.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-span-6">
                      <div class="text-xs">Fecha entrega</div>
                      <div
                        class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
                      >
                        <input
                          type="date"
                          class="input w-full border mt-2 flex-1"
                          v-model="filter.date"
                        />
                      </div>
                    </div>
                    <div class="col-span-6">
                      <div class="text-xs">Codigo</div>
                      <input
                        type="text"
                        class="input w-full border mt-2 flex-1"
                        placeholder="Buscar por codigo"
                        v-model="filter.slug"
                      />
                    </div>
                    <div class="col-span-6">
                      <div class="text-xs">Creada por</div>
                      <select
                        class="input w-full border mt-2 flex-1"
                        v-model="filter.created_by"
                        required
                      >
                        <option value="null">Seleccione un usuario</option>
                        <option
                          v-for="user in filteredUsersAccount"
                          :value="user.id"
                        >
                          {{ user.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-span-6">
                      <div class="w-full sm:w-auto flex">
                        <button
                          @click="filter = clearFilter()"
                          class="button mt-28 text-white bg-theme-1 shadow-md mr-2"
                        >
                          Borrar Filtro
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="intro-y mb-4 flex flex-col-reverse sm:flex-row items-center"
          >
            <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"></div>
            <div class="w-full sm:w-auto flex">
              <email-download-list-button
                v-if="user.team_id == 1"
                :classname="'mr-2'"
              />
              <button
                @click="viewEmailFinish()"
                class="button button--sm mr-1"
                v-if="account_session"
                :class="
                  completed_emails
                    ? 'bg-theme-1 text-white'
                    : 'border border-theme-1 border-theme-10 text-theme-10'
                "
              >
                {{
                  completed_emails
                    ? 'Quitar cortes finalizados'
                    : 'Ver cortes finalizados'
                }}
              </button>
              <button
                @click="setCreateEmailModal(true)"
                class="button text-white bg-theme-1 shadow-md mr-2"
              >
                Crear Corte
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        class="intro-y flex flex-col-reverse mt-2 zindex-0 sm:flex-row items-center"
        v-else
      >
        <h2 class="intro-y text-lg font-medium mr-auto mt-8">
          Cortes Pendientes
          <app-title-custom v-if="account_session" />
          ({{ filteredEmails.length }})
        </h2>
        <div class="w-full sm:w-auto flex items-center sm:ml-auto mt-0 sm:mt-0">
          <button
            @click="viewAccounts('all')"
            class="button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10"
            v-if="account_session"
          >
            Ver todas las cuentas
          </button>
          <button
            @click="viewAccounts('one')"
            class="button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10"
            v-else
          >
            Ver solo una cuenta
          </button>
        </div>
      </div>
      <!-- END: Filter -->

      <!-- List -->
      <div class="overflow-auto">
        <table class="table table-report mt-8">
          <thead>
            <tr>
              <th class="whitespace-no-wrap">NOMBRE</th>
              <th class="text-center whitespace-no-wrap">PROYECTO</th>
              <th class="text-center whitespace-no-wrap">ESTADO</th>
              <th class="text-center whitespace-no-wrap">FECHA ENTREGA</th>
              <th class="text-center whitespace-no-wrap">ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            <tr class="intro-x zindex-0" v-for="email in filteredEmails">
              <td>
                <a
                  href="#"
                  class="font-medium whitespace-no-wrap"
                  :class="email.urgent == true ? 'text-red-700' : ''"
                >
                  {{ email.urgent == true ? 'URG-' : ''
                  }}{{ email.name.toUpperCase() | limit }} - {{ email.number }}
                </a>
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ email.slug }}
                </div>
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ email.created_at }}
                </div>
              </td>
              <td class="text-center w-40">
                <div class="text-center text-xs">
                  {{ email.campaign_attribute.project_name }}
                </div>
                <div class="text-center text-xs">
                  {{ email.campaign_attribute.project_account_name }} -
                  {{ email.campaign_attribute.project_account_country_prefix }}
                </div>
                <div class="text-gray-600 text-sm whitespace-no-wrap">
                  {{ email.campaign_attribute.name }}
                </div>
              </td>
              <td class="w-40">
                <div class="flex items-center justify-center">
                  <template v-for="user in users">
                    <div
                      class="w-10 h-10 image-fit zoom-in"
                      v-if="email.created_by === user.id"
                      :key="`user-created_by-${email.id}-1`"
                    >
                      <img
                        :alt="email.user_created_name"
                        class="tooltip rounded-full tooltipstered"
                        :src="
                          user.avatar
                            ? user.avatar
                            : `/static/images/profile.png`
                        "
                        :title="email.user_created_name"
                      />
                    </div>
                  </template>
                  <template v-for="user in users">
                    <div
                      class="w-10 h-10 image-fit zoom-in -ml-5"
                      v-if="email.user_id === user.id"
                      :key="`user-user_id-${email.id}-2`"
                    >
                      <img
                        :alt="email.user_name"
                        class="tooltip rounded-full tooltipstered"
                        :src="
                          user.avatar
                            ? user.avatar
                            : `/static/images/profile.png`
                        "
                        :title="email.user_name"
                      />
                    </div>
                  </template>
                  <template v-for="user in users">
                    <div
                      class="w-10 h-10 image-fit zoom-in -ml-5"
                      v-if="email.reviewed_by === user.id"
                      :key="`user-user_id-${email.id}-3`"
                    >
                      <img
                        :alt="user.name"
                        class="tooltip rounded-full tooltipstered"
                        :src="
                          user.avatar
                            ? user.avatar
                            : `/static/images/profile.png`
                        "
                        :title="user.name"
                      />
                    </div>
                  </template>
                </div>
                <div class="flex items-center justify-center">
                  {{ email.state_name
                  }}{{ email.hours ? ` - ${email.hours} hs` : '' }}
                </div>
              </td>
              <td class="text-center">
                <button
                  class="button button--sm w-24 text-white"
                  :class="dateClass(email)"
                >
                  {{ email.date }}
                </button>
              </td>
              <td class="table-report__action w-56">
                <div class="flex justify-center items-center">
                  <a
                    @click="showEmailClassification(email)"
                    class="cursor-pointer flex items-center pr-3"
                  >
                    <app-icon name="file" classname="w-4 h-4 mr-2" /> Tipos
                  </a>
                  &nbsp;
                  <a
                    @click="viewEmail(email)"
                    class="cursor-pointer flex items-center pr-3"
                    v-if="email.state_id >= 5"
                  >
                    <app-icon name="eye" classname="w-5 h-5 mr-2" /> Ver
                  </a>
                  &nbsp;
                  <div v-if="email.state_id != 6">
                    <button
                      type="button"
                      @click="editElement(email)"
                      class="cursor-pointer flex items-center pr-3"
                      v-if="
                        email.campaign_attribute.account_id ==
                        auth_session_account
                      "
                    >
                      <app-icon name="edit" classname="w-4 h-4 mr-2" /> Editar
                    </button>
                    <button
                      type="button"
                      @click="viewAccountEmail(email)"
                      class="cursor-pointer flex items-center pr-3"
                      v-else
                    >
                      <app-icon name="folder" classname="w-4 h-4 mr-2" />Editar
                    </button>
                  </div>
                  <router-link
                    :to="`/admin/emails-check/${email.id}`"
                    class="cursor-pointer flex items-center pr-3"
                    v-if="email.state_id >= 5"
                  >
                    <app-icon name="edit" classname="w-4 h-4 mr-2" /> Check
                  </router-link>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- END: List -->
    </div>

    <app-loading v-else />

    <CreateEmailModal
      v-if="createEmailModal"
      :nums="nums"
      :email="email"
      :user="user"
      @closeModal="setCreateEmailModal(false)"
      @emailCreated="emailCreated()"
    />

    <EmailClassificationModal
      v-if="emailClassification"
      :email="emailClassification"
      @closeModal="closeEmailClassificationModal()"
    />

    <ViewEmailModal
      v-if="email_view"
      :email="email_view"
      :versions="email_view.versions"
      @closeModal="email_view = null"
    />
  </section>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'
import EmailClassificationModal from '@/components/admin/email/EmailClassificationModal'
import EmailDownloadListButton from '@/components/admin/email/EmailDownloadListButton'
import TitleCustom from '@/components/admin/partials/TitleCustom'
import EmailEditModal from '@/components/admin/email/EmailEditModal'
import ViewEmailModal from '@/components/admin/email/ViewEmailModal'
import CreateEmailModal from '@/components/admin/email/CreateEmailModal'

import { handleDateClass } from '@/services/DateClass'
import { todayFormat } from '@/services/TodayFormat'

export default {
  name: 'AdminEmailTeam',
  data() {
    return {
      loading: false,
      boxedit: false,
      email: this.defineEmail(),
      email_current: {
        project_id: null,
        campaign_id: null,
      },
      filter: this.clearFilter(),
      account_session: null,
      version: this.defineVersion(),
      version_current: this.defineVersion(),
      nums: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      isUserEmployee: false,
      emailClassification: null,
      email_view: null,
      createEmailModal: false,
      completed_emails: false,
    }
  },
  async beforeMount() {
    await this.routeQuery()
    this.getList('emailstate')
    this.getList('user')
  },
  mounted() {
    this.today = todayFormat()
  },
  methods: {
    defineEmail() {
      return {
        name: '',
        number: '',
        date: '',
        campaign_id: '',
        entity: 'email',
        path: '',
        project_id: '',
        created_by: '',
        today: null,
        urgent: 0,
      }
    },
    clearFilter() {
      return {
        state: null,
        slug: '',
        date: null,
        name: null,
        created_by: null,
      }
    },
    defineVersion() {
      return {
        entity: 'emailversion',
      }
    },
    setCreateEmailModal(boolean) {
      this.createEmailModal = boolean
    },
    async routeQuery() {
      const routeQuery = this.$route.query
      const accountSession = routeQuery.account
        ? routeQuery.account
        : localStorage.session_account
      this.SESSION_ACCOUNT(accountSession)

      if (this.$route.path === '/admin/pendings-emails') {
        this.account_session = null
      } else {
        this.account_session = accountSession
      }
      this.auth_session_account = accountSession
      this.isUserEmployee = this.user.team_id == 1

      let query = this.defineQuery()

      try {
        const { list } = await this.getListEmailsMongo(['email', query])
        this.loading = true

        const emailId = parseInt(this.$route.query.email)

        if (emailId) {
          const email = list.find((x) => x.id === emailId)

          if (email) {
            this.editElement(email)
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    defineQuery() {
      let completed_emails = this.completed_emails ? 'completed' : 'default'

      let query = `account_session=${this.account_session}&states=${completed_emails}`

      if (
        this.$route.path === '/admin/pendings-emails' &&
        this.account_session == null &&
        this.user.accounts.length
      ) {
        query = `account_session=${this.user.accountsIds}&states=pending`
      }
      //console.log(query)
      return query
    },
    async editElement(value) {
      let view = {
        entity: 'emailversion',
        id: value.id,
      }
      value.versions = await this.show(view)

      window.scrollTo(0, 0)

      this.email_current = JSON.parse(JSON.stringify(value))
      this.boxedit = true
    },
    async viewEmail(email) {
      let view = {
        entity: 'emailversion',
        id: email.id,
      }
      email.versions = await this.show(view)

      this.email_view = email
    },
    closeEditEmail() {
      //console.log("close edit email")
      this.boxedit = false
      this.email_current = {}
      //this.$router.push('/admin/emails')
      this.$router.replace('/admin/emails')
    },
    viewAccountEmail(e) {
      localStorage.session_account = e.campaign_attribute.project_account_id
      this.$router.push(
        '/admin/emails?email=' +
          e.id +
          '&account=' +
          e.campaign_attribute.project_account_id
      )
      //window.location.reload()
    },
    viewAccounts(val) {
      let query = ''

      if (val == 'all') {
        query = `account_session=${this.user.accountsIds}`
        this.account_session = null
      } else {
        this.account_session = localStorage.session_account
        query = `account_session=${this.account_session}`
      }

      try {
        this.getList(['email', query])
      } catch (error) {}
    },
    showEmailClassification(email) {
      this.emailClassification = email
    },
    emailCreated() {
      this.email = this.defineEmail()
      this.createEmailModal = false
    },
    emailEdited() {
      this.loading = false
      this.email = this.defineEmail()
      this.boxedit = false
      this.$router.replace('/admin/emails')
      window.location.reload()
    },
    dateClass(email) {
      return handleDateClass('email', email, this.today)
    },
    closeEmailClassificationModal() {
      this.emailClassification = null
      this.getEmailsReload()
    },
    getEmailsReload() {
      this.loading = false
      setTimeout(async () => {
        await this.routeQuery()
        this.loading = true
      }, 500)
    },
    viewEmailFinish() {
      this.completed_emails = !this.completed_emails

      let query = ''
      query = this.defineQuery()

      try {
        this.getListEmailsMongo(['email', query])

        this.loading = true
      } catch (error) {}
    },
    ...mapMutations(['SESSION_ACCOUNT']),
    ...mapActions(['getList', 'getListEmailsMongo', 'store', 'update', 'show']),
  },
  computed: {
    ...mapGetters({
      emails: 'getEmails',
      campaigns: 'getCampaigns',
      user: 'getUser',
      users: 'getUsers',
      usersession: 'getUser',
      states: 'getEmailStates',
      projects: 'getProjects',
    }),
    filteredEmails() {
      return this.emails.filter((item) => {
        var pending =
          this.$route.path === '/admin/pendings-emails'
            ? item.state_id <= 4
            : true
        var slug = this.filter.slug
          ? item.slug.toLowerCase().includes(this.filter.slug.toLowerCase())
          : true
        var name = this.filter.name
          ? item.name.toLowerCase().includes(this.filter.name.toLowerCase())
          : true
        var date = this.filter.date ? this.filter.date == item.date : true
        var state = this.filter.state
          ? this.filter.state == item.state_id
          : true
        var created_by = this.filter.created_by
          ? this.filter.created_by == item.created_by
          : true

        return pending && slug && name && date && state && created_by
      })
    },
    filteredUsers() {
      return this.users.filter((user) => {
        return user.team_id == 1
      })
    },
    filteredUsersAccount() {
      return this.users.filter((item) => {
        var accounts_ids = item.accountsIds
        var search = accounts_ids.indexOf(parseInt(this.account_session))

        return search !== -1
      })
    },
    filteredStates() {
      return this.states.filter((state) => {
        return localStorage.session_team == 1 ? state : state.id == 6
      })
    },
  },
  watch: {
    '$route.query': {
      handler(newVal) {
        if (newVal.email) {
          const email = this.emails.find((x) => x.id === Number(newVal.email))
          if (email) {
            this.editElement(email)
          }
        }
      },
      deep: true,
    },
  },
  components: {
    appIcon: Icon,
    appLoading: Loading,
    appTitleCustom: TitleCustom,
    EmailClassificationModal,
    EmailDownloadListButton,
    ViewEmailModal,
    EmailEditModal,
    CreateEmailModal,
    handleDateClass,
    todayFormat,
  },
}
</script>



// WEBPACK FOOTER //
// EmailTeam.vue?d80f67b6